import type { CSSProperties } from 'react';
import { PACKING_SLIP_INNER_SEPARATE_TABLE_STYLE } from './packingSlipPrintTableShell';

/** Single source of truth for MIXT line-items header (print slip + DOM row measurement). */
export const MIXT_LINE_ITEMS_THEAD_COLUMNS: readonly { label: string; thStyle: CSSProperties }[] = [
    {
        label: 'SKU',
        thStyle: {
            fontWeight: 'bold',
            padding: 4,
            width: '20%',
            whiteSpace: 'nowrap',
            borderBottom: '1px solid #000',
        },
    },
    {
        label: 'Product Name',
        thStyle: {
            fontWeight: 'bold',
            padding: 4,
            width: '30%',
            whiteSpace: 'nowrap',
            borderBottom: '1px solid #000',
        },
    },
    {
        label: 'Qty',
        thStyle: {
            fontWeight: 'bold',
            padding: 4,
            textAlign: 'right',
            whiteSpace: 'nowrap',
            borderBottom: '1px solid #000',
        },
    },
    {
        label: 'Unit Price',
        thStyle: { fontWeight: 'bold', padding: 4, textAlign: 'right', borderBottom: '1px solid #000' },
    },
    {
        label: 'Tax Paid',
        thStyle: { fontWeight: 'bold', padding: 4, textAlign: 'right', borderBottom: '1px solid #000' },
    },
    {
        label: 'Final Cost',
        thStyle: { fontWeight: 'bold', padding: 4, textAlign: 'right', borderBottom: '1px solid #000' },
    },
];

function cssPropertiesToInlineAttr(style: CSSProperties): string {
    return (Object.entries(style) as [string, string | number][])
        .filter(([, v]) => v !== undefined && v !== null && v !== '')
        .map(([camel, val]) => {
            const kebab = camel.replaceAll(/[A-Z]/g, (m) => `-${m.toLowerCase()}`);
            const value = typeof val === 'number' ? `${val}px` : String(val);
            return `${kebab}:${value}`;
        })
        .join(';');
}

/** `<thead>…</thead>` string for `measureMixtOrderItemRowHeights` (must match `MixtLineItemsThead`). */
export function buildMixtLineItemsTheadHtml(): string {
    const cells = MIXT_LINE_ITEMS_THEAD_COLUMNS.map(
        ({ label, thStyle }) =>
            `<th style="${cssPropertiesToInlineAttr(thStyle)}">${escapeHtmlForAttr(label)}</th>`,
    ).join('');
    return `<thead><tr>${cells}</tr></thead>`;
}

function escapeHtmlForAttr(s: string): string {
    return s
        .replaceAll('&', '&amp;')
        .replaceAll('<', '&lt;')
        .replaceAll('>', '&gt;')
        .replaceAll('"', '&quot;');
}

/** MIXT line-items `<thead>` (SKU … Final Cost) — reused in chrome continuation + default slip. */
export function MixtLineItemsThead(): JSX.Element {
    return (
        <thead>
            <tr>
                {MIXT_LINE_ITEMS_THEAD_COLUMNS.map(({ label, thStyle }) => (
                    <th key={label} style={thStyle}>
                        {label}
                    </th>
                ))}
            </tr>
        </thead>
    );
}
/** Inner 6-column table shell: header + empty body (measurement chrome-continuation-header). */
export function MixtLineItemsTableChromeEmpty(): JSX.Element {
    return (
        <table style={PACKING_SLIP_INNER_SEPARATE_TABLE_STYLE}>
            <MixtLineItemsThead />
            <tbody />
        </table>
    );
}
